import React from 'react';
import svtlibCookie from '@svt/cookie';
import { StyledCookieMessage } from './CookieMessage.styles';

class CookieMessage extends React.Component {
    componentDidMount() {
        svtlibCookie('PlayCookieInformationRoot');
    }

    render() {
        return <StyledCookieMessage id="PlayCookieInformationRoot" />;
    }
}

export default CookieMessage;
